import React from 'react';

import { locale, getSupportedProsLabel } from '@trqk/utils';
import { CSVHelpInfo, IconX, IconInfoCircle } from '@trqk/components';

const supportedProsLabel = getSupportedProsLabel('and');

export const PROStatementHelp = ({
    close,
}: RenderTooltipMessageProps): JSX.Element => (
    <div className="text-tertiary-500 bg-white pb-4">
        <div className="flex justify-end px-2 pt-2">
            <IconX
                addClasses="respond-to-mouse"
                width={16}
                fillColor="tertiary-400"
                handleClick={close}
            />
        </div>
        <div className="px-8 mt-2">
            <div className="font-semibold text-lg mb-2">
                {locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.PRO_PROVIDES_PDF_CSV}
            </div>
            <div className="mt-4 mb-4 italic text-xs text-tertiary-400 flex items-center">
                <IconInfoCircle
                    fillColor="tertiary-400"
                    width={16}
                    addClasses="mr-1"
                />
                {`${locale.enUS.SUPPORTED_PROS} ${supportedProsLabel}.`}
            </div>
            <div className="text-sm mb-4">
                <ol className="list-decimal leading-loose">
                    <li>
                        {
                            locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS
                                .STEP_1.PART_1
                        }
                        &nbsp;
                        <span className="font-bold">
                            {
                                locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS
                                    .STEP_1.PART_2
                            }
                        </span>
                    </li>
                    <li>
                        {
                            locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS
                                .STEP_2.PART_1
                        }
                        &nbsp;
                        <span className="font-bold">
                            {
                                locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS
                                    .STEP_2.PART_2
                            }
                        </span>
                    </li>
                    <li>
                        {locale.enUS.HELP.DOWNLOAD_PRO_STATEMENTS.STEPS.STEP_3}
                    </li>
                </ol>
            </div>
            <CSVHelpInfo />
        </div>
    </div>
);
